import Form from "react-bootstrap/Form";

export default function CustomizeInputFile({
  txt,
  Icon,
  iconTxt,
  onChange,
  id,
}) {
  return (
    <>
      <label htmlFor={id} className="w-100" onChange={(e) => onChange(e)}>
        <Form.Control type="file" id={id} hidden />
        <div
          className="d-flex justify-content-between align-items-center rounded-pill  p-1"
          style={{
            border: "2px solid rgb(163 163 126)",
            // borderImage:
            //   "linear-gradient(to right, rgb(215, 215, 177), beige,rgb(226 226 197)) 1",
            // borderRadius: 20,
            fontSize: 14,
          }}
        >
          <div className="ms-2 me-1">{txt}</div>
          <div
            className="btn bg-warning rounded-pill px-3"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgb(215, 215, 177) , beige,rgb(226 226 197))",
            }}
          >
            <span className="me-2" style={{ fontSize: 12 }}>
              {" "}
              {iconTxt}
            </span>
            <Icon />
          </div>
        </div>
      </label>
    </>
  );
}
